import styled from 'styled-components';

export const Home = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	background-color: #F5F5F5;
	@media only screen and (max-width: 600px) {
		background-color: #FFF;
	}
`;

Home.Container = styled.div`
	background-color: #FFF;
	max-width: 800px;
	border-radius: 12px;

	@media only screen and (min-width: 600px) {
		margin: 16px auto;
	}

	@media only screen and (max-width: 600px) {
		flex-direction: column;
		padding: 16px;
		border-radius: 0;
		height: calc(100vh - 165px);
	}
`;

Home.Title = styled.p`
	font-family: 'Inter', sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: 20px;
	line-height: 28px;
	color: #14191E;
`;

Home.Subtitle = styled.p`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #26282A;
	margin-bottom: 0;
	margin-top: 8px;
`;

Home.Card = styled.div`
	background: #FFFFFF;
	box-shadow: 1px 2px 5px rgba(38, 40, 42, 0.16);
	border-radius: 8px;
`;

Home.Card.CompanyName = styled.div`
	font-weight: 500;
	font-size: 16px;
	line-height: 19px;
	color: #26282A;
`;

Home.Card.CompanyContact = styled.div`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #4E5255;
`;

Home.DesktopFooter = styled.div`
	display: none;

	@media only screen and (min-width: 600px) {
		display: block;
	}
`;

Home.FooterContainer = styled.div`
	display: block;
	position: fixed;
	bottom: 0;
	padding: 16px;
	background-color: white;
	width: 100%;
	box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);

	@media only screen and (min-width: 600px) {
		display: none;
	}
`;

Home.Footer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: flex-end;

	@media only screen and (max-width: 599px) {
		margin-top: -24px;
	}
`;

Home.Footer.AcceptedTerm = styled.div`
	display: flex;
	margin-top: 40px;
	margin-bottom: 8px;
	align-items: center;
	gap: 4px;
`;

Home.Footer.AcceptedTerm.Label = styled.label`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	align-items: center;
	color: #26282A;
	cursor: pointer;
`;

Home.Footer.AcceptedTerm.Content = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	column-gap: 6px;
	row-gap: 2px;
`;

Home.Footer.AcceptedTerm.Link = styled.a`
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: #008cff !important;
	text-decoration: none;
	cursor: pointer;
`;

Home.Footer.AcceptedTerm.Separator = styled.span`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #4E5255;
`;
